import BsTab from "./BsTab";
import BsTabs from "./BsTabs";

export default Vue => {
    Vue.component(BsTab.name, BsTab);
    Vue.component(BsTabs.name, BsTabs);
};
